export default "__VITE_ASSET__21033383__"